/** @jsx h */
import { h } from 'preact'
import Packaging from './Packaging'

const Facility = ({ name, location, packaging }) => {
  return (
    <li class='ModalCard-listItem--block'>
      <p>
        Recycle <Packaging packagingList={packaging} /> here:
      </p>
      {location.address &&
        <p class='u-marginTop4'>
          <address class='RecyclingResults-address'>
            {name ? name + ', ' + location.address : location.address}
          </address>
        </p>}
    </li>
  )
}

export default Facility
